module.exports = __webpack_public_path__ + "static/media/pay-top-success3.c858065f.png";